import React, { useMemo } from 'react';
import { RTCTask } from '../../../../core/models/rtc';
import { Card, Typography } from '@mui/material';

const Frame = styled(Card)((props: { alpha: number }) => ({
    boxSizing: 'border-box' as const,
    width: '321px',
    height: '134px',

    background: `rgba(31, 34, 51, ${props.alpha})`,
    border: '0.5px solid #6f6f6e',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    color: 'white',
}));

const CaptionFrame = styled.div({
    position: 'absolute',
    left: 0,

    height: '100%',
    width: '50%',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const Caption = styled(Typography)({
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    textAlign: 'center',
    lineHeight: '120%',
    letterSpacing: '0.2em',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    margin: '0 1em',
});

const IconFrame = styled.div({
    position: 'absolute',
    right: 0,

    width: '184px',
    height: '134px',
});

import AvoidanceLeftIcon from '../../resources/icons/rtc/AvoidanceLeftIcon.svg';
import AvoidanceRightIcon from '../../resources/icons/rtc/AvoidanceRightIcon.svg';
import PullOverIcon from '../../resources/icons/rtc/PullOverIcon.svg';
import PullOutIcon from '../../resources/icons/rtc/PullOutIcon.svg';
import styled from '@emotion/styled';

function iconForTask(task: RTCTask): [string, React.FC<{}>] {
    switch (task.taskType) {
        case 'AVOIDANCE_LEFT':
            return ['avoid to the left', AvoidanceLeftIcon];
        case 'AVOIDANCE_RIGHT':
            return ['avoid to the right', AvoidanceRightIcon];
        case 'GOAL_PLANNER':
            return ['pull over / change goal', PullOverIcon];
        case 'START_PLANNER':
            return ['departing along the path', PullOutIcon];
        default:
            return ['unsupported action', React.Fragment];
    }
}

export type RTCTaskCardProps = {
    className?: string;
    task: RTCTask;
    alpha: number;
}

export function RTCTaskCard(props: RTCTaskCardProps) {
    const { className, task, alpha } = props;

    const [caption, Icon] = useMemo(() => iconForTask(task), [task]);

    return (
        <Frame className={className} alpha={alpha}>
            <CaptionFrame><Caption>{caption}</Caption></CaptionFrame>
            <IconFrame><Icon /></IconFrame>
        </Frame>
    );
}
